import React, { Component } from 'react';
import moment from 'moment';
import { Table } from 'reactstrap';

class TableHistoryBilling extends Component {

    render() {
        return (
            <div className="row table-family">
                {!this.props.loading && (
                    <div className="col-12">
                        {this.props.historicoFaturamento.length > 0 ? (
                            [<div key={1} className="row">
                                <div className="col-12 text-center">
                                    <h6>Histórico de faturamento</h6>
                                </div>
                            </div>,
                            <Table key={2} bordered>
                                <thead>
                                    <tr>
                                        <th>Data</th>
                                        <th>Status</th>
                                        <th>Descrição</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.historicoFaturamento.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{moment(item.dtCriacao).format("DD/MM/YYYY HH:mm")}</td>
                                                <td>{item.nome}</td>
                                                <td>{item.msg}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>]
                        ) : (
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <p>Nenhum registro de faturamento.</p>
                                    </div>
                                </div>
                            )}
                    </div>

                )}

            </div>
        )
    }
}

export default TableHistoryBilling;